function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 14,
  viewBox: "0 0 37 14",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#23B15E",
  fillRule: "evenodd",
  d: "M2 0h25.218a8 8 0 0 1 7.753 6.027l1.395 5.48A2 2 0 0 1 34.427 14H1a1 1 0 0 1-1-1V2a2 2 0 0 1 2-2m1 2a1 1 0 0 0-1 1v4h6V2zm7 0v5h6V2zm8 0v5h6V2zm8 0v5h7l-.122-.48C32.201 3.861 29.962 2 27.218 2z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/occupancy/ic-train-head.svg";
export { SvgComponent as ReactComponent };